import { useQuery } from "@tanstack/react-query";
import useApi from "../../shared/hooks/useApi";
import { PatientId } from "../../shared/schema/schema";
import { Flex, Progress } from "@chakra-ui/react";
import PatientPhysicianEdit from "./PatientPhysicianEdit";
import { PatientPhysicianDisplay } from "./PatientPhysicianDisplay";

export default function PatientPrimaryPhysician(props: {
  isEdit: boolean;
  patientId: PatientId;
  /** After the primary physician was changed or removed (edit mode). */
  onChanged?: () => void;
  /** Whether a change is saving (edit mode). */
  onSavingChange?: (isSaving: boolean) => void;
}) {
  const { queries } = useApi();

  const primaryPhysicianQuery = useQuery(
    queries.patientPhysician.getPrimaryPhysician(props.patientId)
  );

  if (primaryPhysicianQuery.isPending) {
    return (
      <Flex p={4} w="full">
        <Progress isIndeterminate size="xs" w="full" />
      </Flex>
    );
  }

  if (primaryPhysicianQuery.isError) {
    return <Flex w="full">Error Loading Data</Flex>;
  }

  return (
    <Flex p={4} w="full">
      {props.isEdit ? (
        <PatientPhysicianEdit
          patientId={props.patientId}
          physician={primaryPhysicianQuery.data.physician}
          onChanged={props.onChanged}
          onSavingChange={props.onSavingChange}
        />
      ) : (
        <PatientPhysicianDisplay physician={primaryPhysicianQuery.data.physician} />
      )}
    </Flex>
  );
}
